var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.52791V1.08333C0 0.796016 0.111942 0.520465 0.311199 0.317301C0.510456 0.114137 0.780707 0 1.0625 0L15.9375 0C16.2193 0 16.4895 0.114137 16.6888 0.317301C16.8881 0.520465 17 0.796016 17 1.08333V1.52791L8.5 6.94457L0 1.52791ZM8.78156 8.0428C8.69711 8.09655 8.59955 8.12504 8.5 8.12504C8.40045 8.12504 8.30289 8.09655 8.21844 8.0428L0 2.80543V11.9167C0 12.204 0.111942 12.4795 0.311199 12.6827C0.510456 12.8859 0.780707 13 1.0625 13H15.9375C16.2193 13 16.4895 12.8859 16.6888 12.6827C16.8881 12.4795 17 12.204 17 11.9167V2.80543L8.78156 8.0428Z",
    fill: "url(#paint0_linear_2068_65)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2068_65",
    x1: -1.40602,
    y1: 2.90179,
    x2: 20.5626,
    y2: 6.1102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA5332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#DA5332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78524"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.63a6a516ea3ce6d52d8a3e39f837c59a.svg";
export { ForwardRef as ReactComponent };